import { type Href, router } from 'expo-router';
import { ArrowRightIcon } from 'lucide-react-native';

import { Icon } from '../icons/Icon';
import { type BaseRowProps, Row } from './Row';

export interface NavigationRowProps extends BaseRowProps {
    disabled?: boolean;
    href?: Href;
}

/**
 * Row component for navigation actions.
 * Use this for rows that navigate to another screen or section.
 * If onPress is provided, it will override the default router.navigate behavior.
 * When disabled, the row is grayed out and does not respond to press events.
 */
export const NavigationRow = ({
    disabled,
    href,
    onPress,
    ...rowProps
}: NavigationRowProps) => {
    const handlePress =
        disabled === true
            ? undefined
            : (onPress ??
              (() => {
                  if (href == null) {
                      return;
                  }

                  router.navigate(href);
              }));

    return (
        <Row
            {...rowProps}
            containerProps={{
                ...rowProps.containerProps,
                ...(disabled === true && { opacity: 0.6 }),
            }}
            onPress={handlePress}
            rightContent={<Icon color="$black" icon={ArrowRightIcon} />}
        />
    );
};
